module.exports = __webpack_public_path__ + "static/media/HindVadodara-SemiBold.890b5d4e.eot";